import React, { useRef } from 'react'
import Highlighter from 'react-highlight-words'
import { searchWords } from '../../data/Constants'
import useIntersection from '../../hooks/useIntersection'


const BLACK_AND_WHITE = true

function TimelineEntry(props) {
  const ref = useRef()
  useIntersection(ref, "-30px")

  const [before, after] = props.title.split(props.highlight)

  const logo = BLACK_AND_WHITE && props.bwLogo ? props.bwLogo : props.logo

  return (
    <div className="timelineEntry" ref={ref}>
      <div className={`timelineEntry-logo ${BLACK_AND_WHITE ? "make-white" : ""}`}>
        <img src={logo} alt={`${props.highlight} Logo`}/>
      </div>
      <div className="timelineEntry-text">
        <h2>
          {before}
          <span className="timelineEntry-highlight">{props.highlight}</span>
          {after}
        </h2>
        <h3>{props.date}</h3>
        <ul>
          {props.description.map((bullet, i) => 
            <li key={i}><p>
              <Highlighter 
                textToHighlight={bullet}
                searchWords={searchWords}
              />
            </p></li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default TimelineEntry
